import { render, staticRenderFns } from "./LevelReviewsTable.vue?vue&type=template&id=c6d06fcc&"
import script from "./LevelReviewsTable.vue?vue&type=script&lang=ts&"
export * from "./LevelReviewsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports